import lyndys from './images/lyndys.svg';
import hadena from './images/hadena.svg';
import gol from './images/gol.svg';
import phocles from './images/phocles.svg';
import khrom from './images/khrom.svg';
import onixath from './images/onixath.svg';


export const characters = [
    {
        id: 0,
        name: 'Lyndys',
        type: 'Valiant Knight',
        attack: 190,
        defense: 190,
        hp: 190,
        avatar: lyndys,
    },
    {
        id: 1,
        name: 'Hadena',
        type: 'Noble Archer',
        attack: 200,
        defense: 170,
        avatar: hadena,
        hp: 180,
    },
    {
        id: 2,
        name: 'Gol',
        type: 'Dark Dragon',
        attack: 200,
        defense: 150,
        avatar: gol,
        hp: 250,
    },
    {
        id: 3,
        name: 'Onixath',
        type: 'Light Dragon',
        attack: 230,
        defense: 175,
        avatar: onixath,
        hp: 275,
    },
    {
        id: 4,
        name: 'Khrom',
        type: 'Magic Wizard',
        attack: 230,
        defense: 175,
        avatar: khrom,
        hp: 275,
    },
    {
        id: 5,
        name: 'Phocles',
        type: 'Dark Elf',
        attack: 230,
        defense: 175,
        avatar: phocles,
        hp: 275,
    },
]

